import { useState, useEffect } from 'react';

export default function usePageLoader(delay = 1200) {
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setLoading(false), delay);
    return () => clearTimeout(t);
  }, []);
  return loading;
}
